import { Pipe, PipeTransform } from '@angular/core';
import type { ICartItemSelection } from '@mitter-group/contracts';

/**
 * Las opciones elegidas de un renglon del pedido, agrupadas para mostrar:
 * `['Tamaño: Grande', 'Extras: Aceitunas, Queso']`.
 *
 * Lee `ICartItem.selections` (contracts 0.8.0), que el cliente escribe planas y en el orden
 * de los grupos del plato. Agrupa por `groupId` y respeta el orden de llegada. Es la misma
 * regla que `selectionGroups()` de `mitter-client-app` (`core/cart-lines.ts`).
 *
 * Es un pipe puro: solo recalcula cuando cambia el arreglo, no en cada deteccion de cambios.
 */
@Pipe({
  name: 'selectionGroups',
  standalone: false
})
export class SelectionGroupsPipe implements PipeTransform {
  transform(selections: readonly ICartItemSelection[] | null | undefined): string[] {
    const groups = new Map<string, { name: string; options: string[] }>();
    for (const selection of selections ?? []) {
      const group = groups.get(selection.groupId) ?? { name: selection.groupName, options: [] };
      group.options.push(selection.optionName);
      groups.set(selection.groupId, group);
    }
    return [...groups.values()].map((group) => `${group.name}: ${group.options.join(', ')}`);
  }
}
